import { render, staticRenderFns } from "./aideRoleComponent.vue?vue&type=template&id=729879ac&"
import script from "./aideRoleComponent.vue?vue&type=script&lang=js&"
export * from "./aideRoleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports